import { render, staticRenderFns } from "./BtxForm.vue?vue&type=template&id=52371df8&scoped=true&"
import script from "./BtxForm.vue?vue&type=script&lang=js&"
export * from "./BtxForm.vue?vue&type=script&lang=js&"
import style0 from "./BtxForm.vue?vue&type=style&index=0&id=52371df8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52371df8",
  null
  
)

export default component.exports